import React from "react";
import "./GirlsBranch.css";
import { useNavigate } from "react-router-dom";

const FACILITIES = [
  { icon: "🏫", label: "Smart Classrooms" },
  { icon: "🔬", label: "Science & Computer Labs" },
  { icon: "📚", label: "Library" },
  { icon: "⚽", label: "Play Area & Sports Ground" },
  { icon: "🚌", label: "Safe Transport Service" },
];

const ADDRESS = "5F98+VHC, Naveed Town, Multan, Pakistan";
const PHONE_DISPLAY = "+92 302 6854636";
const PHONE_LINK = "+923026854636";
const EMAIL = "academicgroupofschools@gmail.com";

const MAP_EMBED_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.3671270567776!2d71.4637997!3d30.1696937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b33d2d9477c2b%3A0x6d91a4c6e2a1c1ab!2s5F98%2BVHC%20Multan!5e0!3m2!1sen!2s!4v1695400000000!5m2!1sen!2s";

const DIRECTIONS_URL = "https://www.google.com/maps/place/5F98%2BVHC+Multan";

function GirlsBranch() {
  const navigate = useNavigate();

  return (
    <main className="bb">
      {/* Hero */}
      <header className="bb-hero">
        <div className="bb-hero__inner">
          <span className="bb-hero__badge">Academic Group of Schools</span>
          <h1 className="bb-hero__title">Girls Branch</h1>
          <p className="bb-hero__text">
            Welcome to the Girls Branch campus. We are dedicated to nurturing
            academic excellence and holistic development for our students.
          </p>
          <button
            type="button"
            className="bb-btn bb-btn--light"
            onClick={() => navigate("/ApplyForm")}
          >
            Apply Now
          </button>
        </div>
      </header>

      <div className="bb-content">
        {/* About */}
        <section className="bb-section" aria-labelledby="bb-about">
          <h2 id="bb-about" className="bb-section__title">
            About Our Branch
          </h2>
          <p className="bb-section__text">
            Our Girls Branch is designed with modern classrooms, advanced
            laboratories, sports facilities, and a highly qualified faculty. We
            emphasize discipline, learning, and extracurricular activities to
            build strong future leaders.
          </p>
        </section>

        {/* Facilities */}
        <section className="bb-section" aria-labelledby="bb-facilities">
          <h2 id="bb-facilities" className="bb-section__title">
            Facilities
          </h2>
          <ul className="bb-facilities">
            {FACILITIES.map((item) => (
              <li key={item.label} className="bb-facilities__item">
                <span className="bb-facilities__icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Contact */}
        <section className="bb-section" aria-labelledby="bb-contact">
          <h2 id="bb-contact" className="bb-section__title">
            Contact Information
          </h2>
          <div className="bb-contact">
            <div className="bb-contact__card">
              <span className="bb-contact__icon" aria-hidden="true">
                📍
              </span>
              <div>
                <h3 className="bb-contact__label">Address</h3>
                <p className="bb-contact__value">{ADDRESS}</p>
              </div>
            </div>

            <div className="bb-contact__card">
              <span className="bb-contact__icon" aria-hidden="true">
                📞
              </span>
              <div>
                <h3 className="bb-contact__label">Phone</h3>
                <p className="bb-contact__value">
                  <a href={`tel:${PHONE_LINK}`}>{PHONE_DISPLAY}</a>
                </p>
              </div>
            </div>

            <div className="bb-contact__card">
              <span className="bb-contact__icon" aria-hidden="true">
                ✉️
              </span>
              <div>
                <h3 className="bb-contact__label">Email</h3>
               <p className="bb-contact__value">
  <a className="bb-contact__email" href={`mailto:${EMAIL}`}>
    {EMAIL}
  </a>
</p>
              </div>
            </div>
          </div>
        </section>

        {/* Map */}
        <section className="bb-section" aria-labelledby="bb-map">
          <h2 id="bb-map" className="bb-section__title">
            Find Us on Map
          </h2>
          <div className="bb-map">
            <iframe
              title="Girls Branch Location"
              src={MAP_EMBED_SRC}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            href={DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bb-btn bb-btn--primary"
          >
            📍 Get Directions
          </a>
        </section>
      </div>
    </main>
  );
}

export default GirlsBranch;
